import { gql } from 'graphql-request';
import { ChartIds } from 'src/shared/types';

export const fungalFunctionalDiversityMetricsQuery = gql`
    query fungalFuncDivMetricsData($projectId: String!, $fromDate: String, $toDate: String, $habitatAssay: String!) {
        fungalFunctionalDiversity: chart(
            projectId: $projectId, 
            chartId: "${ChartIds.FUNGAL_FUNCTIONAL_DIVERSITY}", 
            habitatAssay: $habitatAssay,
            fromDate: $fromDate, 
            toDate: $toDate
        ) {
            data
        }
    }
`;

export type FungalFunctionalDiversityMetricsChartData = {
    data: {
        data: {
            datetime: string;
            group: {
                type: string;
                value: number;
            }[];
        }[];
        metric: string;
    }[];
};

export type FungalFunctionalDiversityMetricsQueryResult = {
    fungalFunctionalDiversity: FungalFunctionalDiversityMetricsChartData;
};
